import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Faq from "./pages/Faq";
import Home from "./pages/Home";
import Header from './components/header/Header'
import Footer from "./components/footer/Footer";
import Course from "./pages/Course";
import Aos from "aos";
import Enrollment from "./pages/Enrollment";
import Payment from "./pages/Payment";
import ScrollToTop from "./pages/scrollToTop";
import Chat from "./components/chat/Chat";
import Blog from "./pages/Blog";
import Blog1 from "./pages/Blog1";
import Blog2 from "./pages/Blog2";
import Blog3 from "./pages/Blog3";



// Demo styles, see 'Styles' section below for some notes on use.
function App() {

  useEffect(() => {
    Aos.init({ duration: 1500 });
  }, []);
  

  return (
    
    <div className="App">
     <Router>
       <ScrollToTop />
       <Chat />
       <Header />
       <Switch>

         <Route exact path='/' component={Home}/>
         <Route path='/about' component={About}/>
         <Route path='/faq' component={Faq}/>
         <Route path='/blog' component={Blog}/>
         <Route path='/blog-1' component={Blog1}/>
         <Route path='/blog-2' component={Blog2}/>
         <Route path='/blog-3' component={Blog3}/>
         <Route path='/course' component={Course}/>
         <Route path='/contact' component={Contact}/>
         <Route path='/enrollment' component={Enrollment}/>
         <Route path='/enrollment/payment' component={Payment}/>
         <Route path='/*' component={Home}/>
       </Switch>
       <Footer />
     </Router>
    </div>
  );
}

export default App;
